import { render, staticRenderFns } from "./StaffAddFormComponent.vue?vue&type=template&id=10784209"
import script from "./StaffAddFormComponent.vue?vue&type=script&lang=ts"
export * from "./StaffAddFormComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports